import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { ConnectionService } from '../../services/connection.service';
@Component({
  selector: 'app-policies',
  templateUrl: './policies.page.html',
  styleUrls: ['./policies.page.scss'],
})
export class PoliciesPage implements OnInit {

  appData: any;
  apptrackerdata: any;
  userdetails: any;
  applicatnId: any;
  showtrackdetails: boolean;
  showpolicyDetails: boolean;
  showpolicyList: boolean;
  showdownloadbtn: boolean;
  showbuttonpolicy: boolean;
  leads: boolean;
  quote: boolean;
  sales: boolean;
  BRE: boolean;
  appnumberg: boolean;
  BRERejected: boolean;
  Payments: boolean;
  ACR: boolean;
  Thankyus: boolean;
  uthanku: boolean;
  showpaynow: boolean;
  appNo: any = '';
  statusData: any;
  parameterDetails: any;
  resParamDetails: any;
  reqParamDetails: any;
  paynowvalue: any;
  abc: any;
  ////
  iciciPendingFlow: boolean = false;
  hdfcPendingFlow: boolean = false;
  starPendingFlow: boolean = false;
  iciciRedirectUrl: any;
  ////
  showPolicyData: any = {
    'productName': '',
    'insuranceProvider': '',
    'insuranceCategory': '',
    'applicationNumber': '',
    'policyNumber': '',
    'startDate': '',
    'endDate': '',
    'lifeCoverAmount': '',
    'totalPremium': '',
    'addOn_ci_coverAmount': '',
    'addOn_ci_premium': '',
    'addOn_ci_term': '',
    'addOn_ad_coverAmount': '',
    'addOn_ad_premium': '',
    'addOn_ad_term': '',
    'premiumFreq': '',
    'vehicleBrand': '',
    'vehicleModel': '',
    'deductible_amount': '',
  }
  access_token: string;

  hdfcAppStatus: any;

  careHealthFlow: boolean = false;
  careEnhanceFlow: boolean = false;
  careRidersList: any = [];
  appStatus: any;

  hdfcTermFlow: boolean = false;
  hdfcRidersList: any = [];
  hdfcRedirectUrl: any;

  iciciTermFlow: boolean = false;
  starHealthFlow: boolean = false;
  starRedirectUrl: any;

  lombardVehicleFlow: boolean = false;
  addonsRiskDetail: any;
  addonsArry: any = [];
  addsArry: any;
  showField: boolean;
  addons: { HandicapDiscount: any; RoadSideAssistance: any; ElectricalAccessories: any; NonElectricalAccessories: any; ZeroDepreciation: any; AntiTheftDisc: any; AutomobileAssocnFlag: any; LegalLiabilityToPaidDriver: any; PACoverUnnamedPassenger: any; EngineProtect: any; LossOfPersonalBelongings: any; KeyProtect: any; Consumables: any; PaCoverForOwnerDriver: any; ReturnToInvoice: any; basicOD: any; };
  lombardDetail: any;
  lombardBreakinStatus: boolean;
  appNumber: any;
  paymentRedirectedUrl: any;
  lombardBreakinStatusFailed: boolean;
  starTopUp: boolean;

  constructor(private strg: StorageService,
    private apiService: ConnectionService,
    private loader: LoaderService,
    private router: Router,
    private toast: ToastService,
    private authService: AuthenticationService,
    private _dataFields: DataFieldsService) {
    this.strg.getStoreData("userObj").then(res => {
      this.userdetails = res;
      console.log('userdetailsss', this.userdetails.id);
    });

    this.strg.getStoreData("insAccessToken").then(res => {
      this.access_token = res;
    });
  }

  //Star top up data fields start
  fhoSumInsuredList: any = this._dataFields.getFhoSumInsuredList();
  mciSumInsuredList: any = this._dataFields.getMciSumInsuredList();
  fhoCompfYsfSchemeIdList = this._dataFields.getFhoCompfYsfSchemeMasterList();
  rcfSumInsuredList: any = this._dataFields.getRcfSumInsuredList();
  rcfSchemeIdList = this._dataFields.getRcfSchemeMasterList();
  rciSumInsuredList: any = this._dataFields.getRciSumInsuredList();
  compfCompiSumInsuredList: any = this._dataFields.getcompfCompiSumInsuredList();
  ysfSumInsuredList: any = this._dataFields.getYsfSumInsuredList();
  ysiSumInsuredList: any = this._dataFields.getYsiSumInsuredList();
  //Star top up data fields end

  policyListReq: any = {
    policyStatus: "PENDING", // ACTIVE, PENDING, EXPIRED, RENEWAL
    policyType: "ALL", // ALL, TERM, HEALTH, TOP-UP, VEHICLE
  }

  ngOnInit() {
    this.loader.showLoader("Please Wait...");
    setTimeout(() => {
      // // this.apiService.getTransactionDetails(this.userdetails.id).subscribe(res=>{ //for direct ref
      // // this.policyListReq.policyStatus = ""
      // this.apiService.getTransactionDetails(this.policyListReq).subscribe(res=>{
      //   this.loader.hideLoader();
      //   this.appData = res.data;   
      //   console.log(res.data)         
      //   // this.appData = this.appData.reverse();
      //   this.appData = this.appData;
      // }, err => { this.loader.hideLoader(); });   
      this.getPoliciesList();
    }, 500);
  }

  async getPoliciesList() {
    // this.loader.showLoader();
    await this.apiService.getTransactionDetails(this.policyListReq).subscribe(res => {
      // this.loader.hideLoader();
      // this.appData = res.data;
      let apiData = res.data;
      this.appData = [];
      this.showLoading = false;
      console.log("policy list", apiData)
      if (this.policyListReq.policyStatus === "PENDING") {
        this.appData = this.policyListReq.policyType == "ALL" ? apiData?.healthPendingPolicyList?.concat(apiData?.termPendingPolicyList, apiData?.vehiclePendingPolicyList, apiData?.topUpPendingPolicyList)
          : this.policyListReq.policyType == "HEALTH" ? apiData?.healthPendingPolicyList
            : this.policyListReq.policyType == "TOP-UP" ? apiData?.topUpPendingPolicyList
              : this.policyListReq.policyType == "VEHICLE" ? apiData?.vehiclePendingPolicyList
                : this.policyListReq.policyType == "TERM" ? apiData?.termPendingPolicyList : [];
      }
      else if (this.policyListReq.policyStatus === "EXPIRED") {
        this.appData = this.policyListReq.policyType == "ALL" ? apiData?.healthExpiredPolicyList?.concat(apiData?.termExpiredPolicyList, apiData?.vehicleExpiredPolicyList, apiData?.topUpExpiredPolicyList)
          : this.policyListReq.policyType == "HEALTH" ? apiData?.healthExpiredPolicyList
            : this.policyListReq.policyType == "TOP-UP" ? apiData?.topUpExpiredPolicyList
              : this.policyListReq.policyType == "VEHICLE" ? apiData?.vehicleExpiredPolicyList
                : this.policyListReq.policyType == "TERM" ? apiData?.termExpiredPolicyList : [];
      }
      else if (this.policyListReq.policyStatus === "ACTIVE") {
        this.appData = this.policyListReq.policyType == "ALL" ? apiData?.healthActivePolicyList?.concat(apiData?.termActivePolicyList, apiData?.vehicleActivePolicyList, apiData?.topUpActivePolicyList)
          : this.policyListReq.policyType == "HEALTH" ? apiData?.healthActivePolicyList
            : this.policyListReq.policyType == "TOP-UP" ? apiData?.topUpActivePolicyList
              : this.policyListReq.policyType == "VEHICLE" ? apiData?.vehicleActivePolicyList
                : this.policyListReq.policyType == "TERM" ? apiData?.termActivePolicyList : [];
      }
      else if (this.policyListReq.policyStatus === "RENEWAL") {
        this.appData = this.policyListReq.policyType == "ALL" ? apiData?.healthRenewalPolicyList?.concat(apiData?.termRenewalPolicyList, apiData?.vehicleRenewalPolicyList, apiData?.topUpRenewalPolicyList)
          : this.policyListReq.policyType == "HEALTH" ? apiData?.healthRenewalPolicyList
            : this.policyListReq.policyType == "TOP-UP" ? apiData?.topUpRenewalPolicyList
              : this.policyListReq.policyType == "VEHICLE" ? apiData?.vehicleRenewalPolicyList
                : this.policyListReq.policyType == "TERM" ? apiData?.termRenewalPolicyList : [];
      }

      if (this.appData === undefined) {
        this.appData = [];
        this.getPoliciesList();
      }
      console.log("to show policy list", this.appData)
      this.loader.hideLoader();
    }, err => { this.loader.hideLoader(); this.showLoading = false; });
  }

  applyFilterData() {

  }

  redirectToICICI() {
    if (this.iciciPendingFlow) {
      window.open(this.iciciRedirectUrl, "_blank");
    }
  }
  iciciPayment(data) {
    this.apiService.createTransaction(data).subscribe(res => {
      console.log(res)
      window.open(res.data, "_self");
    })
  }
  redirectToHDFC() {
    if (this.hdfcPendingFlow) {
      window.open(this.hdfcRedirectUrl, "_blank");
    }
  }

  redirectToSTAR() {
    if (this.starPendingFlow) {
      window.open(this.starRedirectUrl, "_blank");
    }
  }

  trackApplicationStatus(data) {
    if (data) {
      ////
      this.iciciRedirectUrl = "";
      this.iciciPendingFlow = false;
      ////
      console.log(data, 'iiiiiiiiii');
      this.appNo = data;
      this.loader.showLoader("Please Wait...");

      ////
      let lineItem = this.appData.filter(item => item.applicationNumber === this.appNo);
      if (lineItem.length != 0) {
        this.iciciRedirectUrl = lineItem[0].redirectUrl;
      }
      ////

      this.apiService.getIcIcApplicationStatus(data).subscribe(res => {
        this.loader.hideLoader();
        console.log(res, 'bbbbbbbbbbbbbb');
        this.paynowvalue = res.data.paymentStatus;
        if (this.paynowvalue === "NOT DONE") {
          this.showpaynow = true;
        }
        else {
          this.showpaynow = false;
        }
        this.showtrackdetails = true;
        this.showpolicyList = true;
        this.appNo = '';
        this.statusData = res.data.overallStatus;

        //////
        if (this.statusData.includes('L') && this.statusData.includes('E')
          && this.statusData.includes('A') && this.statusData.includes('B')) {
          // && this.statusData.includes('P') && this.statusData.includes('T')){
          this.iciciPendingFlow = true;
        } else {
          this.iciciPendingFlow = false;
        }
        //////

        if (this.statusData.includes('L')) {
          this.leads = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('E')) {
          this.quote = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('S')) {
          this.sales = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('A')) {
          this.appnumberg = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('B')) {
          this.BRE = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('R')) {
          this.BRERejected = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('P')) {
          this.Payments = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('C')) {
          this.ACR = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('T')) {
          this.Thankyus = true;
        }
        else {
          console.log('No data');
        }
        if (this.statusData.includes('U')) {
          this.uthanku = true;
        }
        else {
          console.log('No data');
        }
        this.applicatnId = res.data.appNo;
        console.log("this.statusData", this.statusData);
      }, err => {
        this.loader.hideLoader();
        console.log(err, "error");
      });
    }
  }

  backtoPolicy() {
    this.showtrackdetails = false;
    this.showpolicyDetails = false;
    this.showpolicyList = false;
    this.showbuttonpolicy = false;
  }

  policydetails(data) {
    console.log(data, 'iiiiiiiiii');
    this.appNo = data;
    this.showpolicyDetails = true;
    this.showpolicyList = true;
    this.showbuttonpolicy = true;
  }

  logoutClicked() {
    this.authService.revokeAuthTokenOnLogout(this.access_token, this.userdetails.id).subscribe(ress => {
      console.log("token revoked!")
      this.strg.removeStoreData("userObj").then(res => {
        this.strg.removeStoreData("insAccessToken").then(res => {
          this.strg.removeStoreData("insRefreshToken").then(res => {
            this.authService.authState.next(false);
            // this.router.navigate(['/login']);
            // this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url }});
            window.open("https://www.mypolicyjunction.com/", "_self");
          });
        });
      });
    });
  }

  getDetails(data) {
    this.iciciTermFlow = false;
    this.careHealthFlow = false;
    this.hdfcTermFlow = false;
    this.starHealthFlow = false;
    this.lombardVehicleFlow = false;

    this.showdownloadbtn = false;

    this.iciciPendingFlow = false;
    this.hdfcPendingFlow = false;
    this.starPendingFlow = false;
    this.careEnhanceFlow = false;

    this.hdfcRidersList = [];
    this.careRidersList = [];

    this.iciciRedirectUrl = "";
    this.hdfcRedirectUrl = "";
    this.starRedirectUrl = "";
    this.showPolicyData.startDate = "";
    this.showPolicyData.endDate = "";
    this.showPolicyData.policyNumber = "";
    console.log("product details", data);
    console.log(data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.name)
    let productName = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.name;
    this.applicatnId = data.applicationNumber;
    this.showPolicyData.policyNumber = data.policyNumber;
    console.log("application no", this.applicatnId)
    // this.parameterDetails = JSON.parse(data.parameter);
    // console.log("parameter details", this.parameterDetails);
    this.resParamDetails = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam)
    console.log("res param details", this.resParamDetails);
    this.reqParamDetails = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.reqParam)
    console.log("req param details", this.reqParamDetails);
    this.showpolicyDetails = true;
    this.showpolicyList = true;
    this.showbuttonpolicy = true;
    this.showPolicyData.productName = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.name;
    this.showPolicyData.insuranceProvider = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceProvider.name;
    this.showPolicyData.insuranceCategory = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceCategories.name;
    this.showPolicyData.applicationNumber = data.applicationNumber;
    console.log("product name", productName);
    if (productName === "ICICI Pru iProtect Smart") {
      this.iciciTermFlow = true;
      // this.showPolicyData.productName = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.name;
      // this.showPolicyData.insuranceProvider = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceProvider.name;
      // this.showPolicyData.insuranceCategory = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceCategories.name;
      // this.showPolicyData.applicationNumber = data.applicationNumber;
      this.showPolicyData.lifeCoverAmount = this.resParamDetails.deathBenefit;
      this.showPolicyData.totalPremium = this.resParamDetails.totalFirstPremiumShow;
      this.showPolicyData.policyCoverTerm = this.resParamDetails.term;
      this.showPolicyData.premiumFreq = this.resParamDetails.modeOfPayment;
      this.showPolicyData.addOn_ci_premium = this.resParamDetails.totalPremium_CI;
      this.showPolicyData.addOn_ad_premium = this.resParamDetails.totalPremium_ADB;
      this.showPolicyData.addOn_ci_term = this.resParamDetails.term;
      this.showPolicyData.addOn_ad_term = this.resParamDetails.term;
      this.showPolicyData.addOn_ci_coverAmount = this.resParamDetails.cirsumAssured;
      this.showPolicyData.addOn_ad_coverAmount = this.resParamDetails.adbSumAssured;
      if (this.showPolicyData.addOn_ci_premium === "" || this.showPolicyData.addOn_ci_premium === 0 || this.showPolicyData.addOn_ci_premium === "0") {
        this.showPolicyData.addOn_ci_term = "0";
      }
      if (this.showPolicyData.addOn_ad_premium === "" || this.showPolicyData.addOn_ad_premium === 0 || this.showPolicyData.addOn_ad_premium === "0") {
        this.showPolicyData.addOn_ad_term = "0";
      }
      console.log(this.showPolicyData, "policy details");
      this.trackApplicationStatus(this.applicatnId);
      this.trackIciciApplication(this.applicatnId);
    } else if (productName === "HDFC Life Click 2 Protect Life") {
      ///todo hdfc handling
      this.hdfcTermFlow = true;
      console.log("resParamDetails", this.resParamDetails);
      this.hdfcRedirectUrl = data.redirectUrl;

      // this.showPolicyData.productName = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.name;
      // this.showPolicyData.insuranceProvider = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceProvider.name;
      // this.showPolicyData.insuranceCategory = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceCategories.name;
      // this.showPolicyData.applicationNumber = data.applicationNumber;
      this.showPolicyData.lifeCoverAmount = this.resParamDetails.POD.sumAssured;
      this.showPolicyData.totalPremium = this.resParamDetails.totPremium;
      this.showPolicyData.policyCoverTerm = this.resParamDetails.POD.term;
      this.showPolicyData.premiumFreq = this.resParamDetails.POD.freq;
      if (this.resParamDetails.rider) {
        let riderObj;
        this.resParamDetails.rider.forEach(item => {
          if (item.name === "C4CI") {
            riderObj = {
              "riderName": "Critical Illness Benefit Rider",
              "riderSumAssured": String(item.sumAssured),
              "riderTerm": String(item.term),
              "riderPPT": String(item.ppt),
              "riderPremiumAmount": String(item.premium + item.tax)
            }
            this.hdfcRidersList.push(riderObj);
          }
          if (item.name === "PPR_CC") {
            riderObj = {
              "riderName": "Cancer Cover Benefit Rider",
              "riderSumAssured": String(item.sumAssured),
              "riderTerm": String(item.term),
              "riderPPT": String(item.ppt),
              "riderPremiumAmount": String(item.premium + item.tax)
            }
            this.hdfcRidersList.push(riderObj);
          }
          if (item.name === "INAD") {
            riderObj = {
              "riderName": "Income Benefit on Accidental Disability Rider",
              "riderSumAssured": String(item.sumAssured),
              "riderTerm": String(item.term),
              "riderPPT": String(item.ppt),
              "riderPremiumAmount": String(item.premium + item.tax)
            }
            this.hdfcRidersList.push(riderObj);
          }
          if (item.name === "PPR_ADC") {
            riderObj = {
              "riderName": "Accidental Death Benefit Rider",
              "riderSumAssured": String(item.sumAssured),
              "riderTerm": String(item.term),
              "riderPPT": String(item.ppt),
              "riderPremiumAmount": String(item.premium + item.tax)
            }
            this.hdfcRidersList.push(riderObj);
          }
          if (item.name === "PPR_PAC") {
            riderObj = {
              "riderName": "Personal Accident Cover Benefit Rider",
              "riderSumAssured": String(item.sumAssured),
              "riderTerm": String(item.term),
              "riderPPT": String(item.ppt),
              "riderPremiumAmount": String(item.premium + item.tax)
            }
            this.hdfcRidersList.push(riderObj);
          }
        })
      }
      this.trackHdfcApplication(this.applicatnId);
    } else if (productName === "CARE") {
      this.careHealthFlow = true;
      // this.showPolicyData.productName = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.name;
      // this.showPolicyData.insuranceProvider = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceProvider.name;
      // this.showPolicyData.insuranceCategory = data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.insuranceProductDetails.insuranceCategories.name;
      // this.showPolicyData.applicationNumber = data.applicationNumber;
      this.showPolicyData.lifeCoverAmount = this.resParamDetails?.careQuoteResponse.responseParam.inputFields[5].selectedValue;
      this.showPolicyData.totalPremium = this.resParamDetails?.careQuoteResponse.responseParam.grandTotal.selectedValue.replace(/,/g, '');
      this.showPolicyData.policyCoverTerm = this.resParamDetails?.careQuoteResponse.responseParam.inputFields.find(i => i.fieldName === 'field_4').selectedValue;
      this.showPolicyData.premiumFreq = "";
      this.showPolicyData.addOn_ci_premium = this.resParamDetails.totalPremium_CI;
      this.showPolicyData.addOn_ad_premium = this.resParamDetails.totalPremium_ADB;
      this.showPolicyData.addOn_ci_term = this.resParamDetails.term;
      this.showPolicyData.addOn_ad_term = this.resParamDetails.term;
      this.showPolicyData.addOn_ci_coverAmount = this.resParamDetails.cirsumAssured;
      this.showPolicyData.addOn_ad_coverAmount = this.resParamDetails.adbSumAssured;
      this.careRidersList = this.resParamDetails.careQuoteResponse.responseParam.extraFields.filter(item => { item.label != "" && item.selectedValue != 0 })
      console.log(this.resParamDetails.careQuoteResponse.responseParam.extraFields)
      this.applicatnId = Number(data.applicationNumber);
      this.trackCareApplication(this.applicatnId);
    } else if (productName === "Family Health Optima" || productName === "Medi-Classic Individual" || productName === "Red Carpet Floater" || productName === "Red Carpet Individual"
      || productName === "Comprehensive Floater" || productName === "Comprehensive Individual" || productName === "Young Star Floater" || productName === "Young Star Individual") {
      this.starHealthFlow = true;
      this.starRedirectUrl = data.redirectUrl;
      //Getting premium cover amount start
      console.log(this.reqParamDetails, 'asdasd')
      if (productName === 'Medi-Classic Individual') {
        let suminsured = this.mciSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.insureds[0].sumInsuredId)
        console.log(suminsured.value, '0909090909')
        this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Family Health Optima') {
        let suminsured = this.fhoSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.sumInsuredId)
        console.log(suminsured.value, '0909090909')
        this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Red Carpet Floater') {
        let suminsured = this.rcfSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.sumInsuredId)
        console.log(suminsured.value, '0909090909')
        this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Comprehensive Floater') {

        console.log('jhgjhg');
        console.log("aksjhdjkahdsk adshkajd shjkadh kajdhs", this.reqParamDetails)
        // let suminsured = this.compfCompiSumInsuredList.find(item => item.siId === this.reqParamDetails?.starHealthQuoteRequest?.sumInsuredId)
        // console.log(suminsured.value, '0909090909')
        // this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Young Star Floater') {
        let suminsured = this.ysfSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.sumInsuredId)
        console.log(suminsured.value, '0909090909')
        this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Red Carpet Individual') {
        let suminsured = this.rciSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.insureds[0].sumInsuredId)
        console.log(suminsured.value, '0909090909')
        this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Comprehensive Individual') {
        let suminsured = this.compfCompiSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.insureds[0].sumInsuredId)
        console.log(suminsured.value, '0909090909')
        this.showPolicyData.lifeCoverAmount = suminsured.value
      }
      else if (productName === 'Young Star Individual') {
        let suminsured = this.ysiSumInsuredList.find(item => item.siId === this.reqParamDetails.starHealthQuoteRequest.insureds[0].sumInsuredId)
        console.log(suminsured.value, '0909090909');
        this.showPolicyData.lifeCoverAmount = suminsured.value;
      }
      console.log(JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam), '1100011')
      //Getting premium cover amount end
      // this.showPolicyData.premiumFreq = this.resParamDetails.modeOfPayment;
      // this.showPolicyData.startDate = data.intGetPolicyStatusIO.policyCommencementDt;
      // this.showPolicyData.endDate = data.intGetPolicyStatusIO.policyMaturityDt;
      console.log("kjashdkajhsdkjhdkjahds", this.resParamDetails);
      this.showPolicyData.totalPremium = this.resParamDetails.responseParam.totalPremium;

      if (this.reqParamDetails.starHealthQuoteRequest.period) {
        this.showPolicyData.policyCoverTerm = this.reqParamDetails.starHealthQuoteRequest.period + " Year";
      } else {
        this.showPolicyData.policyCoverTerm = "1 Year";
      }
      this.trackStarPolicyStatus(this.applicatnId);
    } else if (productName === "ICICI Lombord FW") {
      let lombData = JSON.parse(data.parameter)
      console.log(data)
      this.lombardVehicleFlow = true;
      this.lombardDetail = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam)
      this.addonsRiskDetail = lombData.appSubResponse.riskDetails
      console.log(this.addonsRiskDetail, JSON.parse(data.parameter))
      let lombardBreakStatus = JSON.parse(data.parameter)
      if (lombardBreakStatus.inspectionStatus && lombardBreakStatus.inspectionStatus === "PASS") {
        this.appNumber = lombardBreakStatus.appSubResponse.generalInformation.proposalNumber
        this.lombardBreakinStatus = true;
        this.lombardBreakinStatusFailed = false;
        this.paymentRedirectedUrl = data.redirectUrl
        this.appStatus = 'Application Success'
      }
      else if (lombardBreakStatus.inspectionStatus && lombardBreakStatus.inspectionStatus === "FAIL") {
        this.appNumber = lombardBreakStatus.appSubResponse.generalInformation.proposalNumber
        this.lombardBreakinStatus = false;
        this.lombardBreakinStatusFailed = true;
        // this.paymentRedirectedUrl=data.redirectUrl
        this.appStatus = 'Application Failed'
      }
      else {
        this.lombardBreakinStatus = false;
        if (this.showPolicyData.policyNumber) {
          console.log("this.showPolicyData.policyNumber", this.showPolicyData.policyNumber)
          this.showdownloadbtn = true;
          this.appStatus = "Policy Inforce";
        } else {
          this.appStatus = "Application Pending";
        }
      }
      //this.showPolicyData.policyNumber=lombData.
      this.showPolicyData.vehicleModel = this.lombardDetail.responseParam.generalInformation.manufacturerName
      this.showPolicyData.lifeCoverAmount = ''//this.addonsRiskDetail.responseParam.finalPremium
      this.showPolicyData.totalPremium = this.lombardDetail.responseParam.finalPremium
      this.showPolicyData.startDate = lombData.appSubResponse.generalInformation.proposalDate
      this.showPolicyData.endDate = lombData.appSubResponse.generalInformation.policyEndDate
      console.log(this.addonsRiskDetail.riskDetails, '9080808098')
      this.addons = {
        HandicapDiscount: this.addonsRiskDetail.handicappedDiscount,
        RoadSideAssistance: this.addonsRiskDetail.roadSideAssistance,
        ElectricalAccessories: this.addonsRiskDetail.electricalAccessories,
        NonElectricalAccessories: this.addonsRiskDetail.nonElectricalAccessories,
        ZeroDepreciation: this.addonsRiskDetail.zeroDepreciation,
        AntiTheftDisc: this.addonsRiskDetail.antiTheftDiscount,
        AutomobileAssocnFlag: this.addonsRiskDetail.automobileAssociationDiscount,
        LegalLiabilityToPaidDriver: this.addonsRiskDetail.paidDriver,
        PACoverUnnamedPassenger: this.addonsRiskDetail.paCoverForUnNamedPassenger,
        EngineProtect: this.addonsRiskDetail.engineProtect,
        LossOfPersonalBelongings: this.addonsRiskDetail.lossOfPersonalBelongings,
        KeyProtect: this.addonsRiskDetail.keyProtect,
        Consumables: this.addonsRiskDetail.consumables,
        PaCoverForOwnerDriver: this.addonsRiskDetail.paCoverForOwnerDriver,
        ReturnToInvoice: this.addonsRiskDetail.returnToInvoice,
        basicOD: this.addonsRiskDetail.basicOD
      }
      //   this.addonsArry.push(addons)
      //   //let addons=this.addonsArry.filter(item=>item > 0)
      //   //this.addsArry=this.addonsArry[0]
      // console.log(this.addonsArry[0],'012313123213')
      this.parameterDetails = JSON.parse(data.parameter);
      console.log("parameter details", this.parameterDetails);

      this.showPolicyData.lifeCoverAmount = this.parameterDetails.appSubResponse.generalInformation.depriciatedIDV;
      this.showPolicyData.totalPremium = this.parameterDetails.appSubResponse.finalPremium;
      this.showPolicyData.startDate = this.parameterDetails.appSubResponse.generalInformation.policyInceptionDate;
      this.showPolicyData.endDate = this.parameterDetails.appSubResponse.generalInformation.policyEndDate;
      this.showPolicyData.vehicleBrand = this.parameterDetails.appSubResponse.generalInformation.manufacturerName;
      this.showPolicyData.vehicleModel = this.parameterDetails.appSubResponse.generalInformation.vehicleModel;

      if (this.parameterDetails.appSubResponse.generalInformation.tpTenure > 0) {
        console.log(this.parameterDetails.appSubResponse)
        this.showPolicyData.policyCoverTerm = this.parameterDetails.appSubResponse.generalInformation.tenure + " Year Comprehensive Cover + " + this.parameterDetails.appSubResponse.generalInformation.tpTenure + " Years Third-Party Cover";
      } else {
        this.showPolicyData.policyCoverTerm = this.parameterDetails.appSubResponse.generalInformation.tenure + " Year Comprehensive Cover";
      }
    }
    else if (productName === "Super Surplus Floater" || productName === "Super Surplus Individual") {
      this.starTopUp = true;
      let topUpData = data
      console.log(topUpData)
      let coverAmt = JSON.parse(data.insuranceOrderHistory.insuranceQuoteRequest.reqParam)
      console.log('coverAmt', coverAmt)
      let premium = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam)
      if (productName === "Super Surplus Individual") {
        this.showPolicyData.lifeCoverAmount = coverAmt.reqParam.membersArray[0].sumInsuredAmount
        this.showPolicyData.deductible_amount = coverAmt.reqParam.membersArray[0].deductible
      } else {
        this.showPolicyData.lifeCoverAmount = coverAmt.reqParam.sumInsuredAmount
        this.showPolicyData.deductible_amount = coverAmt.reqParam.deductible
      }
      this.showPolicyData.policyCoverTerm = (+coverAmt.reqParam.policyTerm) > 1 ? `${coverAmt.reqParam.policyTerm} Years` : `${coverAmt.reqParam.policyTerm} Year`;;
      this.showPolicyData.totalPremium = premium.totalPremium
      this.appStatus = data.insuranceOrderHistory.status
    } else if (productName === "Enhance 1") {
      console.log('Enhance 1 data', data)
      this.careEnhanceFlow = true;
      let topUpData = data
      console.log(topUpData)
      let coverAmt = JSON.parse(data.insuranceOrderHistory.insuranceQuoteRequest.reqParam)
      console.log('coverAmt', coverAmt)
      let premium = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam)
      console.log('premium', premium)
      if (coverAmt.reqParam.policyType === 'Individual') {
        this.showPolicyData.lifeCoverAmount = coverAmt.reqParam.membersArray[0].sumInsuredAmount
        this.showPolicyData.deductible_amount = coverAmt.reqParam.membersArray[0].deductible
      } else {
        this.showPolicyData.lifeCoverAmount = coverAmt.reqParam.sumInsuredAmount
        this.showPolicyData.deductible_amount = coverAmt.reqParam.deductible
      }
      this.showPolicyData.policyCoverTerm = (+coverAmt.reqParam.policyTerm) > 1 ? `${coverAmt.reqParam.policyTerm} Years` : `${coverAmt.reqParam.policyTerm} Year`;
      // this.showPolicyData.totalPremium = premium.totalPremium
      console.log('this.resParamDetails', this.resParamDetails)
      if (coverAmt.reqParam.hasAddOn) {
        this.showPolicyData.totalPremium = (premium.outputFields.filter(el => el.fieldName === "field_8")[0].premium).replace(/,/g, '')
      } else {
        console.log(premium.outputFields.filter(el => { el.fieldName === "field_14" }))
        this.showPolicyData.totalPremium = (premium.outputFields.filter(el => el.fieldName === "field_14")[0].premium).replace(/,/g, '')
        // this.showPolicyData.totalPremium = this.resParamDetails.careQuoteResponse.responseParam.grandTotal.selectedValue.replace(/,/g, '');
      }
      this.appStatus = data.insuranceOrderHistory.status
    }
    console.log(productName)
  }

  trackIciciApplication(appno) {
    if (appno) {
      this.apptrackerdata = {
        "APPLICATIONKEY": appno,
        "PARTNERKEY": "WJC00153"
      }
      this.apiService.IcIcAppTracker(this.apptrackerdata).subscribe(res => {
        console.log(res, 'tttttttttttt');
        this.showPolicyData.policyNumber = res.data.Envelope.Body.M_PARTNER_APPTRACKER_NEWResponse.M_PARTNER_APPTRACKER_NEWResponseElement[0].POLICYKEY;
        this.showPolicyData.startDate = res.data.Envelope.Body.M_PARTNER_APPTRACKER_NEWResponse.M_PARTNER_APPTRACKER_NEWResponseElement[0].ISSUEDATE;
        this.showPolicyData.endDate = res.data.Envelope.Body.M_PARTNER_APPTRACKER_NEWResponse.M_PARTNER_APPTRACKER_NEWResponseElement[0].POLICY_END_DATE;
        let statuspol = res.data.Envelope.Body.M_PARTNER_APPTRACKER_NEWResponse.M_PARTNER_APPTRACKER_NEWResponseElement[0].POLICYSTATUS;
        if (statuspol === "IF") {
          this.showdownloadbtn = true;
        }
        else {
          this.showdownloadbtn = false;
        }
        console.log(this.showPolicyData.policyNumber, 'yrtryturetye');
      }, err => {
        console.log(err, 'uuuuuuuuu');
      });
    }
  }

  trackHdfcApplication(appno) {
    this.appStatus = "";
    if (appno) {
      let dataa = {
        applicationNumber: appno
      }
      this.apiService.getHdfcApplicationStatus(dataa).subscribe(res => {
        this.appStatus = res.data.appStatus;
        console.log("hdfc app status", res.data, this.appStatus);
        this.showPolicyData.policyNumber = res.data.policyNo;
        if (this.appStatus === "Quote" || this.appStatus === "Requirements Awaited" || this.appStatus === "Payment") {
          this.hdfcPendingFlow = true;
        } else {
          this.hdfcPendingFlow = false;
          if (this.appStatus === "Policy Issued" || this.appStatus === "Pre-Printing") {
            this.showdownloadbtn = true;
          } else {
            this.showdownloadbtn = false;
          }
        }

        if (res.data.appStatus === "Quote") {
          this.appStatus = "Quote generated. Please Continue with the Application!";
        } else if (res.data.appStatus === "Requirements Awaited") {
          this.appStatus = "Upload Required Documents!";
        } else if (res.data.appStatus === "Scrutiny") {
          this.appStatus = "Your Application is Being Processed!";
        } else if (res.data.appStatus === "Underwriting") {
          this.appStatus = "Your Application is Being Processed!";
        } else if (res.data.appStatus === "Initial handle error") {
          this.appStatus = "An Internal Error has Occurred. Please Contact Support Team!";
        } else if (res.data.appStatus === "Final handle error") {
          this.appStatus = "An Internal Error has Occurred. Please Contact Support Team!";
        } else if (res.data.appStatus === "Pre- conversion check") {
          this.appStatus = "Error Occurred due to Fund Transfer/ Receipt Clearance Failure. Please Contact Support Team!";
        } else if (res.data.appStatus === "Cancelled") {
          this.appStatus = "Application is cancelled.";
        } else if (res.data.appStatus === "Policy Issued") {
          this.appStatus = "Policy Issued.";
        } else if (res.data.appStatus === "Payment") {
          this.appStatus = "Payment is pending.";
        } else {
          this.appStatus = res.data.appStatus;
        }
      });
    }
  }

  trackCareApplication(appno) {
    this.appStatus = "";
    if (appno) {
      this.apiService.postCareStatus(appno).subscribe(res => {
        console.log("ggggg", res, JSON.parse(res.data.response))
        let data = JSON.parse(res.data.response);
        console.log("data", data);
        this.showPolicyData.startDate = data.intGetPolicyStatusIO.policyCommencementDt;
        this.showPolicyData.endDate = data.intGetPolicyStatusIO.policyMaturityDt;
        this.appStatus = data.intGetPolicyStatusIO.policyStatus;
        if (this.appStatus === "Inforce") {
          this.showdownloadbtn = true;
        } else {
          this.showdownloadbtn = false;
        }
        if (data.intGetPolicyStatusIO.policyNum) {
          this.showPolicyData.policyNumber = data.intGetPolicyStatusIO.policyNum;
        }
      })
    }
  }

  trackStarPolicyStatus(refId) {
    if (refId != null) {
      this.apiService.getStarPolicyStatus(refId).subscribe(res => {
        console.log("reponse policy status", JSON.parse(res.data))
        let resData = JSON.parse(res.data);
        if (resData.note) {
          this.appStatus = resData.note;
          this.showdownloadbtn = false;
          this.starPendingFlow = true;
        } else if (resData.Policy_Number) {
          this.appStatus = "Policy Inforce";
          this.showdownloadbtn = true;
          this.showPolicyData.applicationNumber = resData.Proposal_Number;
          this.showPolicyData.policyNumber = resData.Policy_Number;
        }
      }, err => {
        console.log("error policy status", err);
      })
    }
  }

  downloadpolicy() {
    // this.applicatnId = this.showPolicyData.applicationNumber;     
    if (this.iciciTermFlow) {
      this.apiService.IcIcpolicydownload(this.showPolicyData.applicationNumber).subscribe(res => {
        window.open(res.data.url, '_self');
      }, err => {
        console.log(err, "error in download");
      })
    }

    if (this.hdfcTermFlow) {
      this.apiService.getHdfcPolicyDoc(this.showPolicyData.policyNumber).subscribe(res => {
        // window.open(res.data.url, '_self');
        let resdata = JSON.parse(res.data);
        let pdfFileData = resdata.body.pdfStream;
        this.showPdf(pdfFileData);
      }, err => {
        console.log(err, "error in download");
      })
    }

    if (this.careHealthFlow) {
      this.apiService.downloadCarePolicyDoc(this.showPolicyData.policyNumber).subscribe(res => {
        window.open(res.data.url, '_self');
      }, err => {
        console.log(err, "error in download");
      })
    }

    if (this.starHealthFlow) {
      this.apiService.downloadStarPolicyDoc(this.applicatnId).subscribe(res => {
        // window.open(res.data.url, '_self');
        console.log("resresresres", res);
        let resdata = res.data;
        // let pdfFileData = resdata.body.pdfStream;
        this.showPdf(resdata);
      }, err => {
        console.log(err, "error in download");
      })
    }

    if (this.lombardVehicleFlow) {
      let data = {
        "CorrelationId": this.parameterDetails.appSubResponse.correlationId,
        "policyNo": this.showPolicyData.policyNumber,
        "customerId": this.parameterDetails.appSubResponse.generalInformation.customerId
      }
      this.apiService.getPolicyDocLombard(data).subscribe(res => {
        console.log("policy doc res", res);
      }, err => {
        console.log("error", err);
      })
    }
  }

  showPdf(res) {
    // let fName = "HDFC_Policy_DOC" + '.pdf';
    let timepstamp = new Date().valueOf();
    let fName = this.hdfcTermFlow ? "HDFC_Policy_DOC_" + timepstamp + '.pdf' : "STAR_Policy_DOC_" + timepstamp + '.pdf';
    let extension = 'pdf';
    let byteCharacters = atob(res);
    let byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], { "type": "image" + "/pdf" });
    if (navigator.msSaveBlob) {
      let filename = fName;
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute('visibility', 'hidden');
      link.download = fName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  // showPolicyData: any = {
  //   'productName': '',//
  //   'insuranceProvider': '',//
  //   'insuranceCategory': '',//
  //   'applicationNumber': '',//
  //   'policyCoverTerm': '',//
  //   'policyNumber': '',
  //   'startDate': '',
  //   'endDate': '',
  //   'lifeCoverAmount': '',//
  //   'totalPremium': '',//
  //   'addOn_ci_premium': '',//
  //   'addOn_ad_premium': '',//
  //   'addOn_ci_coverAmount': '',//
  //   'addOn_ad_coverAmount': '',//
  //   'addOn_ci_term': '',//
  //   'addOn_ad_term': '',//
  //   'premiumFreq': '',//
  // }
  showLoading: boolean = false;
  ShowactivePolicy() {
    // this.showpolicyList = true;
    // this.showpolicyDetails = false;
    this.showpolicyList = false;
    this.policyListReq.policyStatus = "ACTIVE";
    this.showLoading = true;
    this.getPoliciesList();
  }
  showexpirepolicy() {
    // this.showpolicyList = true;
    // this.showpolicyDetails = false;
    this.showpolicyList = false;
    this.policyListReq.policyStatus = "EXPIRED";
    this.showLoading = true;
    this.getPoliciesList();
  }
  showpendingpolicy() {
    this.showpolicyList = false;
    this.policyListReq.policyStatus = "PENDING";
    this.showLoading = true;
    this.getPoliciesList();
  }
  showrenewalpolicy() {
    this.showpolicyList = false;
    this.policyListReq.policyStatus = "RENEWAL";
    this.showLoading = true;
    this.getPoliciesList();
  }

  policyTypeFilterChange(policyType) {
    this.policyListReq.policyType = policyType;
    this.showLoading = true;
    this.getPoliciesList();
    if (policyType === 'VEHICLE') {
      this.showField = false;
    }
    else {
      this.showField = true;
    }
  }

  paybilldesk(data) {
    console.log(data, 'billdeskappnumber');
    let payData = {
      // "email": this.userdetails.email, //for direct ref
      "transactionAmount": 2,
      "igst": "0.00",
      "sgst": 0.00,
      "cgst": 0.00,
      "discountAmount": "0.00",
      "appNumber": data,
      "couponCode": null
    }
    this.loader.showLoader("Please Wait...");
    this.apiService.generateBilldeskData(payData).subscribe(res => {
      console.log("billdesk res", res);
      if (res) {
        this.apiService.sendRedirectRequest(res.data).subscribe(response => {
          this.loader.hideLoader();
          console.log("billdesk redirect res", response);
          window.open(response.url, '_self');
        }, err => {
          this.loader.hideLoader();
          if (err.url) {
            let url = err.url;
            window.open(url, '_self');
          } else {
            let url = err._body.target.__zone_symbol__xhrURL;
            window.open(url, '_self');
          }
          this.loader.hideLoader();
        });
      }

    }, err => {
      this.loader.hideLoader();
      this.toast.showToast(err.error.message);
      console.log(err);
    });
  }

}
